import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyAddressFetchInitData from "./cargo-company-address-fetch-init-data";
import CargoCompanyAddressFetchInitDataParams from "./cargo-company-address-fetch-init-data-params";

const useCargoCompanyAddressFetchInitData = () => {
  const { data, setData, isError, setIsError, isLoading, setIsLoading } =
    useAsyncData<CargoCompanyAddressFetchInitData | null>(null);

  const load = async (
    params: CargoCompanyAddressFetchInitDataParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const cargoCompanyAddressFetchInitData =
        await cargoCompanyService.fetchInitData(params, abortSignal);

      setData(cargoCompanyAddressFetchInitData);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isError,
    isLoading,
    data,
    load,
  };
};

export default useCargoCompanyAddressFetchInitData;
